<template>
  <a-row :gutter="16">
    <a-col v-for="(item,idx) in dataList" :key="idx" :span="4" @click="openDetail(item)">
      <a-card :body-style="{padding:'20px'}" style="border-radius: 8px" size="small">
        <template slot="title">{{ item.lable }}</template>
        <div
          style="height:110px;
        font-weight:500;
        text-align:center;
        font-size:60px;color:#201d1d"
        >
          {{ item.value }}
        </div>
      </a-card>
    </a-col>
    <BusinessRequirementListModal ref="businessRequirementListModalRef" />
  </a-row>
</template>

<script>
import BusinessRequirementListModal from '@/pages/business/requirement/components/BusinessRequirementListModal';
import moment from 'moment';
export default {
  components: { BusinessRequirementListModal },
  props: {
    datas: {
      type: Array,
      default: () => {
        return [];
      }
    },
    filterForm: {
      type: Object,
      default: () => {
        return {
          noDesignDay: 5,
          noDevDay: 20
        };
      }
    }
  },
  data() {
    return {
      tableData: [],
      dataList: [
        { id: 1, lable: this.filterForm.noDesignDay + '天未设计需求', value: 0, ids: [] },
        { id: 2, lable: '未评审需求', value: 0, ids: [] },
        { id: 3, lable: this.filterForm.noDevDay + '天未开发需求', value: 0, ids: [] },
        { id: 4, lable: '待提交验收需求', value: 0 }
      ]
    };
  },
  watch: {
    datas: {
      handler(data) {
        this.tableData = data || [];
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
  },
  methods: {
    openDetail(item) {
      if (item.lable === '追溯总数') {
        this.$refs.businessRequirementListModalRef.open(item.lable);
      } else if (item.lable === '追溯问答中') {
        this.$refs.businessRequirementListModalRef.open(item.lable, { statusList: [134] });
      } else if (item.lable === '进入生产追溯') {
        this.$refs.businessRequirementListModalRef.open(item.lable, { statusList: [135, 136, 137] });
      } else if (item.lable === '已交付') {
        this.$refs.businessRequirementListModalRef.open(item.lable, { statusList: [139] });
      }
    },
    init(data) {
      this.tableData = data || [];
      this.changeData();
    },
    changeData() {
      // { id: 1, lable: '5天未设计需求', value: 0, ids: [] },
      //   { id: 2, lable: '未评审需求', value: 0, ids: [] },
      //   { id: 3, lable: '20天未开发需求', value: 0, ids: [] }
      // 5天未设计需求
      const _data1 = this.dataList.find(item => item.id === 1);
      const _dataList = this.tableData.filter(item => {
        if (item.stepId !== 135 || item.designStatus === 3 || !item.stepTime) {
          // 已完成
          return false;
        }
        const daysDiff = moment().diff(moment(item.stepTime), 'days');
        return daysDiff > this.filterForm.noDesignDay;
      });
      _data1.lable = this.filterForm.noDesignDay + '天未设计需求';
      _data1.value = _dataList.length;
      _data1.ids = _dataList.map(item => item.id);

      // 未评审需求
      const _data2 = this.dataList.find(item => item.id === 2);
      const _dataList2 = this.tableData.filter(item => item.stepId === 149);
      _data2.value = _dataList2.length;
      _data2.ids = _dataList2.map(item => item.id);

      // 20天未开发需求
      const _data3 = this.dataList.find(item => item.id === 3);
      const _dataList3 = this.tableData.filter(item => {
        if (item.stepId !== 136 || !item.stepTime) {
          // 已完成
          return false;
        }
        const daysDiff = moment().diff(moment(item.stepTime), 'days');
        return daysDiff > this.filterForm.noDevDay;
      });
      _data3.lable = this.filterForm.noDevDay + '天未开发需求';
      _data3.value = _dataList3.length;
      _data3.ids = _dataList3.map(item => item.id);

      // 待提交验收需求
      const _data4 = this.dataList.find(item => item.id === 4);
      const _dataList4 = this.tableData.filter(item => item.stepId === 137 && item.noDoneDevReq > 0);
      _data4.value = _dataList4.length;
      _data4.ids = _dataList4.map(item => item.id);
    }
  }
};
</script>

<style lang="less" scoped>

</style>
